import styled from 'react-emotion'

const Input = styled('input')({
    fontFamily: 'Montserrat, sans-serif',
    padding: '15px 20px',
    boxShadow: '0 15px 35px rgba(50,50,93,0.1), 0 5px 15px rgba(0,0,0,0.07)',
    border: 0,
    borderRadius: 4,
    width: '100%',
    boxSizing: 'border-box',
    marginTop: 10,
    outline: 0,
    fontSize: '.9em',
    ':focus': {
        borderColor: '#F06F2F',
        boxShadow:
            '0 15px 35px rgba(50,50,93,0.1), 0 5px 15px rgba(0,0,0,0.07), 0 0 0 0.2rem rgba(240,111,47,0.25)'
    }
})

export default Input


// WEBPACK FOOTER //
// ./src/components/InputComponent.jsx